import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SettingsStateI } from '../types/settings';

const initSettingsState: SettingsStateI = {
    use_ai_assistant: false,
    hide_add_device_popup: false,
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState: initSettingsState,
    reducers:{
        setAIAssistant: (state, action: PayloadAction<boolean>) => {
            state.use_ai_assistant = action.payload;
        },
        setHideAddDevicePopup: (state, action: PayloadAction<boolean>) => {
            state.hide_add_device_popup = action.payload;
        }
    }
});

export const{
    setAIAssistant,
    setHideAddDevicePopup
} = settingsSlice.actions;

export default settingsSlice.reducer;
